import CanonicalTags from "@/components/seo/CanonicalTags";
import MarketingLayout from "@/components/marketing/MarketingLayout";
import { WaitlistForm } from "@/components/waitlist";
import { SignUpCta } from "@/components/marketing/parts";

/** Public /waitlist page: the same form as the waitlist dialog, inline. */
const WaitlistPage = () => (
  <MarketingLayout>
    <CanonicalTags
      path="/waitlist"
      title="Join the Compaire Beta Waitlist"
      description="Join Compaire's beta waitlist to explore real estate teams and brokerages, or introduce your organization to agents. No credit card required."
    />
    <section style={{ padding: "clamp(56px,9cqi,120px) var(--mk-gutter) clamp(80px,10cqi,144px)" }}>
      <div className="mk-stack" style={{ maxWidth: 560, margin: "0 auto", gap: 36 }}>
        <div className="mk-stack" style={{ gap: 16 }}>
          <h1 className="mk-h1" style={{ font: "700 var(--mk-text-cta-lg)/1.04 var(--mk-sans)" }}>
            Join the waitlist
          </h1>
          <p className="mk-body-lg">
            Teams and brokerages: tell us who you are and we'll be in touch about your organization's profile.
          </p>
          {/* Agent sign-up is open (founder decision F6, 2026-10-21): old
              /waitlist links lead agents to sign-up, never onto the list. */}
          <div className="mk-stack" style={{ gap: 12, alignItems: "flex-start" }}>
            <p className="mk-body">Are you an agent? You don't need to wait.</p>
            <SignUpCta variant="outline">Create a free agent account</SignUpCta>
          </div>
        </div>
        <WaitlistForm appearance="marketing" />
      </div>
    </section>
  </MarketingLayout>
);

export default WaitlistPage;
